import React, { useEffect, useState } from 'react';
import automationVideo from '../vid/automation.mp4';
import studioProductionVideo from '../vid/studio-production.mov';
import contentCreationVideo from '../vid/content-creation.mp4';
import videoEditingVideo from '../vid/Video-editing.mp4';
import technicalSolutionVideo from '../vid/technical-solution.mp4';

import { 
  FaBullhorn, 
  FaPaintBrush, 
  FaShare, 
  FaCog, 
  FaCode, 
  FaSearch 
} from 'react-icons/fa';

const Services = () => {
  useEffect(() => {
    // Track services section view - replace with your tracking implementation
    console.log('Services section viewed');
  }, []);

  const [showCallModal, setShowCallModal] = useState(false);
  const [callResult, setCallResult] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleCallSubmit = async (e) => {
    e.preventDefault();
    setCallResult('Sending...');
    
    const submitData = new FormData();
    submitData.append('access_key', '4b701ea6-eb3e-4c6a-a8d8-c13c4196b5de');
    submitData.append('subject', 'Schedule a Call Request');
    submitData.append('name', formData.name);
    submitData.append('email', formData.email);
    submitData.append('phone', formData.phone);
    submitData.append('message', formData.message);

    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: submitData
    });

    const data = await response.json();
    if (data.success) {
      setCallResult('Call Request Sent Successfully');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } else {
      setCallResult('Error sending request. Please try again.');
    }
  };

  const services = [
    {
      icon: <FaBullhorn className="text-4xl text-blue-600 mb-4" />,
      title: "Product Video & Photo Shoots",
      description: "We create cinematic 4K product videos and photos that combine studio quality with natural, social-first style — delivered fast and ad-ready.",
      category: "ADS • ADS • ADS",
      tags: ["Facebook Ads", "Google Ads"],
      mockupType: "product-video"
    },
    {
      icon: <FaPaintBrush className="text-4xl text-purple-600 mb-4" />,
      title: "Content Creation",
      description: "We develop creative concepts and visuals that tell your brand's story with clarity, consistency, and impact across every platform.",
      category: "DESIGN • DESIGN • DESIGN",
      tags: ["Brand Identity", "UI/UX Design"],
      mockupType: "content-creation"
    },
    {
      icon: <FaShare className="text-4xl text-pink-600 mb-4" />,
      title: "Social Media Management",
      description: "We plan, post, and manage your social presence with content, engagement, and analytics that build authority and drive growth.",
      category: "SOCIAL • SOCIAL • SOCIAL",
      tags: ["Facebook Ads", "Google Ads"],
      mockupType: "social-media"
    },
    {
      icon: <FaCog className="text-4xl text-indigo-600 mb-4" />,
      title: "Automations & Funnels",
      description: "We set up WhatsApp flows, CRM, and email systems that turn your audience into customers and your marketing into measurable revenue.",
      category: "AUTO • AUTO • AUTO",
      tags: ["Process Automation", "Workflow Optimization"],
      mockupType: "automation"
    },
    {
      icon: <FaCode className="text-4xl text-teal-600 mb-4" />,
      title: "Technical Solutions",
      description: "We design and build fast, conversion-focused websites and funnels that turn traffic into customers — seamlessly.",
      category: "WEB • WEB • WEB",
      tags: ["Website Development", "Landing Pages"],
      mockupType: "technical-solutions"
    },
    {
      icon: <FaSearch className="text-4xl text-green-600 mb-4" />,
      title: "Search Engine Optimization (SEO)",
      description: "Boost your online swagger! We'll spruce up your website so Google has no choice but to be your biggest fan.",
      category: "SEO • SEO • SEO",
      tags: ["Organic Traffic", "Keyword Optimization"],
      mockupType: "seo"
    }
  ];

  const renderMockup = (type, index) => {
    const mockupClasses = "w-full h-80 bg-gradient-to-br from-pink-100 via-blue-100 to-purple-100 rounded-3xl p-8 shadow-xl relative overflow-hidden";
    
    switch(type) {
      case 'product-video':
        return (
          <div className={mockupClasses}>
            <div className="bg-white rounded-2xl p-6 h-full shadow-lg relative overflow-hidden">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover rounded-xl"
              >
                <source src={studioProductionVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        );
      
      case 'content-creation':
        return (
          <div className={mockupClasses}>
            <div className="bg-white rounded-2xl p-6 h-full shadow-lg relative overflow-hidden">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover rounded-xl"
              >
                <source src={contentCreationVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        );
      
      case 'social-media':
        return (
          <div className={mockupClasses}>
            <div className="bg-white rounded-2xl p-6 h-full shadow-lg relative overflow-hidden">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover rounded-xl"
              >
                <source src={videoEditingVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        );
      
      case 'automation':
        return (
          <div className={mockupClasses}>
            <div className="bg-white rounded-2xl p-6 h-full shadow-lg relative overflow-hidden">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover rounded-xl"
              >
                <source src={automationVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        );
      
      case 'technical-solutions':
        return (
          <div className={mockupClasses}>
            <div className="bg-white rounded-2xl p-6 h-full shadow-lg relative overflow-hidden">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover rounded-xl"
              >
                <source src={technicalSolutionVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        );
      
      case 'web':
        return (
          <div className={mockupClasses}>
            <div className="bg-white rounded-2xl p-6 h-full shadow-lg relative overflow-hidden">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover rounded-xl"
              >
                <source src={technicalSolutionVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        );
      
      case 'seo':
        return (
          <div className={mockupClasses}>
            <div className="bg-white rounded-2xl p-6 h-full shadow-lg relative flex items-center justify-center">
              <div className="text-center">
                <FaSearch className="text-6xl text-green-500 mb-4 mx-auto" />
                <div className="w-32 h-4 bg-gray-200 rounded-full mb-2"></div>
                <div className="w-24 h-4 bg-gray-200 rounded-full mb-2"></div>
                <div className="w-20 h-4 bg-gray-200 rounded-full"></div>
              </div>
            </div>
          </div>
        );
      
      default:
        return (
          <div className={mockupClasses}>
            <div className="bg-white rounded-2xl p-6 h-full shadow-lg relative flex items-center justify-center">
              <div className="text-center">
                {services[index]?.icon}
                <div className="w-32 h-4 bg-gray-200 rounded-full mb-2"></div>
                <div className="w-24 h-4 bg-gray-200 rounded-full mb-2"></div>
                <div className="w-20 h-4 bg-gray-200 rounded-full"></div>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 bg-blue-300 rounded-full blur-xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-purple-300 rounded-full blur-xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-pink-200 rounded-full blur-2xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-purple-100 text-purple-700 rounded-full text-sm font-semibold mb-4">
            NEW!
          </div>
          <h2 className="text-5xl font-bold text-gray-800 mb-4 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            Our Services
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.slice(0, 6).map((service, index) => (
            <div 
              key={index}
              className="group relative bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-white/20 hover:scale-105 hover:-translate-y-2"
            >
              {/* Category Badge */}
              <div className="absolute top-4 right-4">
                <span className="px-3 py-1 bg-gradient-to-r from-purple-100 to-blue-100 text-purple-700 text-xs font-semibold rounded-full">
                  {service.category.split(' • ')[0]}
                </span>
              </div>

              {/* Icon */}
              <div className="flex justify-center mb-6">
                <div className="p-4 bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-md group-hover:shadow-lg transition-shadow duration-300">
                  {service.icon}
                </div>
              </div>

              {/* Content */}
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-800 mb-4 group-hover:text-blue-600 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>

              {/* Hover effect overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-purple-500/5 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mb-20">
          <p className="text-gray-600 mb-6">
            Want to discuss? 
            <button 
              className="ml-2 text-blue-600 hover:text-blue-800 font-semibold underline transition-colors duration-300"
              onClick={() => { setShowCallModal(true); setCallResult(''); }}
            >
              Let's Schedule a Call
            </button>
          </p>
        </div>

        {showCallModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-2xl p-8 w-full max-w-md shadow-lg relative">
              <button
                className="absolute top-3 right-3 text-xl text-gray-500"
                onClick={() => setShowCallModal(false)}
              >
                &times;
              </button>
              {callResult === "Call Request Sent Successfully" ? (
                <div className="text-center">
                  <h2 className="font-bold text-xl mb-4 text-green-600">Thank you!</h2>
                  <p>Your call request has been sent. Our team will contact you soon.</p>
                  <button
                    className="mt-4 text-blue-500 underline"
                    onClick={() => setShowCallModal(false)}
                  >
                    Close
                  </button>
                </div>
              ) : (
                <div className="flex flex-col gap-4">
                  <h2 className="font-bold text-2xl mb-2">Let's Schedule a Call</h2>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    required
                    value={formData.name}
                    onChange={handleInputChange}
                    className="border rounded p-2"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                    className="border rounded p-2"
                  />
                  <input
                    type="text"
                    name="phone"
                    placeholder="Your Phone Number"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="border rounded p-2"
                  />
                  <textarea
                    name="message"
                    placeholder="Message or Preferred Timings"
                    required
                    value={formData.message}
                    onChange={handleInputChange}
                    className="border rounded p-2"
                  />
                  <button onClick={handleCallSubmit} className="bg-blue-600 text-white px-4 py-2 rounded">
                    Submit
                  </button>
                  <span className="text-center text-sm text-gray-500">{callResult}</span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Detailed Service Sections */}
        <div className="space-y-24">
          {services.map((service, index) => (
            <div key={`detail-${index}`} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              {/* Mockup Side */}
              <div className="w-full lg:w-1/2">
                {renderMockup(service.mockupType, index)}
              </div>
              {/* Content Side */}
              <div className="w-full lg:w-1/2 space-y-6">
                <div className="inline-block px-4 py-2 bg-purple-100 text-purple-700 rounded-full text-sm font-semibold">
                  {service.category}
                </div>
                <h3 className="text-4xl font-bold text-gray-800 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  {service.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {service.description}
                </p>
                <div className="flex flex-wrap gap-3">
                  {service.tags.map((tag, tagIndex) => (
                    <span 
                      key={tagIndex}
                      className="px-4 py-2 bg-white/80 text-gray-700 rounded-full text-sm font-medium shadow-sm border border-gray-200"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Decorative bar */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-purple-300 to-transparent"></div>
    </section>
  );
};

export default Services;